import { default as Box } from '@mui/material/Box';
import { default as Card } from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import { default as Toolbar } from '@mui/material/Toolbar';
import { default as Typography } from '@mui/material/Typography';
import { MenuLinkWrapper } from 'components/MenuLink';
import { Text } from 'components/Text';

export const ProfileHeaderText = styled(Typography)(({ theme }) => ({
  color: theme.palette.common.white,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  paddingBottom: 5
}));

export const ProfileHeaderToolbar = styled(Toolbar)(({ theme }) => ({
  height: 144,
  backgroundColor: theme.palette.primary.main,
  [theme.breakpoints.up('sm')]: {
    paddingLeft: 28,
    paddingRight: 28
  }
}));

export const LanguageOptionWrapper = styled(MenuLinkWrapper)(({ theme }) => ({
  backgroundColor: theme.palette.background.default
}));

export const ContactContentCard = styled(Card)(({ theme }) => ({
  borderRadius: '16px',
  paddingLeft: theme.spacing(3),
  paddingRight: theme.spacing(3),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  marginBottom: theme.spacing(5)
}));

export const ContactContentBlock = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(3)
}));

export const ContactTitleBlock = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.75)
}));

export const ContactTitle = styled(Text)(() => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'
}));

export const ContactIconWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  position: 'relative',
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  cursor: 'pointer',
  color: theme.palette.primary.lighter,
  '& svg': {
    fontSize: '1.4rem'
  }
}));
